import React from 'react';
import './style.scss';

const CURRENT_YEAR = new Date().getFullYear();

const Legal = () => (
    <div className="legal">
        <div className="privacy-terms">
            <a className="privacy-policy" href="/privacy-policy" target="_blank">{i18n.t('footer.legal.privacy_policy')}</a>
            <a href="/terms_of_service" target="_blank">{i18n.t('footer.legal.terms_of_service')}</a>
        </div>
        <p className="all-rights">&#169; {i18n.t('footer.legal.all_rights', {year: CURRENT_YEAR})}</p>
    </div>
);

export default Legal;



// WEBPACK FOOTER //
// ./src/components/Legal/index.js